import {
  BrowserModule,
  HAMMER_GESTURE_CONFIG,
  HammerGestureConfig,
} from "@angular/platform-browser";
import { NgModule, ErrorHandler, APP_INITIALIZER } from "@angular/core";
import { LOCALE_ID } from "@angular/core";

import { LayoutComponent } from "./layout/layout.component";

import { registerLocaleData } from "@angular/common";
import localePl from "@angular/common/locales/pl";
import localePlExtra from "@angular/common/locales/extra/pl";

registerLocaleData(localePl, "pl", localePlExtra);

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { DeviceDetectorModule } from "ngx-device-detector";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { JwtInterceptor } from "src/app/auth/jwt.interceptor";
import { ErrorInterceptor } from "./error.interceptor";
import { ToastrModule } from "ngx-toastr";
import { CustomMaterialModule } from "./material.module";
import { RedirectHomeComponent } from "./redirect-home/redirect-home.component";
import { DataService } from "./_services/data.service";
import { PrivilegesService } from "./_services/privileges.service";
import { HammerConfig } from "./hammer-config";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import {NgxsModule} from '@ngxs/store';
import {JbpState} from './pages/joint-business-plan/state/jbp.state';
import {environment} from '../environments/environment';
import {NgxsFormPluginModule} from '@ngxs/form-plugin';

@NgModule({
  declarations: [AppComponent, LayoutComponent, RedirectHomeComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CustomMaterialModule,
    ToastrModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    NgxsModule.forRoot([JbpState], {
      developmentMode: !environment.production
    }),
    NgxsFormPluginModule.forRoot()
  ],
  providers: [
    { provide: LOCALE_ID, useValue: window.navigator.language },
    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    DataService,
    PrivilegesService,
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => {},
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
